module.exports = __webpack_public_path__ + "static/media/icon_close.ea99763a.svg";